jQuery.noConflict();
jQuery(document).ready(function($) {
  var makeUnselectable = function( $target ) {
    $target
    .addClass( 'unselectable' ) // All these attributes are inheritable
    .attr( 'unselectable', 'on' ) // For IE9 - This property is not inherited, needs to be placed onto everything
    .attr( 'draggable', 'false' ) // For moz and webkit, although Firefox 16 ignores this when -moz-user-select: none; is set, it's like these properties are mutually exclusive, seems to be a bug.
    .on( 'dragstart', function() { return false; } );  // Needed since Firefox 16 seems to ingore the 'draggable' attribute we just applied above when '-moz-user-select: none' is applied to the CSS

    $target // Apply non-inheritable properties to the child elements
    .find( '*' )
    .attr( 'draggable', 'false' )
    .attr( 'unselectable', 'on' );
  };
  //If full screen zoom is
  //Load visible images first
  $(window).on('load', function(){
    $('.soff_browse_lot_images_display_image img[src=""]').each(function(){
      $(this).attr('src', $(this).data('img-medium-src'));
    });
    $('.soff_browse_lot_images_controls_thumbnail img[src=""]').each(function(){
      $(this).attr('src', $(this).data('img-thumbnail-src'));
    });
  });

  let thumbnailAmmount = 5;
  //Display previous/next
  $('.soff_browse_lot_images_display_prev').click(function(){
    //Disable full screen zoom when next/prev buttons are clicked
    $('#soff_browse_lot_images').removeClass('soff_fullscreen_gallery_zoom');

    //Kills fadeIn
    $('.soff_browse_lot_images_display_image.shown').stop(true, true);
    //Kills fadeOut
    $('.soff_browse_lot_images_display_image.shown').stop(true, true);

    //Display previous image
    if(!$('.soff_browse_lot_images_display_image').first().hasClass('shown')){
      $('.soff_browse_lot_images_display_image.shown').fadeOut('fast', function(){
        $(this).removeClass('shown').prev().addClass('shown').hide().fadeIn('fast');
      })
      $('.soff_browse_lot_images_controls_thumbnail.active').removeClass('active').prev().addClass('active');
    }
    else{
      $('.soff_browse_lot_images_display_image.shown').fadeOut('fast', function(){
        $(this).removeClass('shown');
        $('.soff_browse_lot_images_display_image').last().addClass('shown').hide().fadeIn('fast');
      })
      $('.soff_browse_lot_images_controls_thumbnail.active').removeClass('active');
      $('.soff_browse_lot_images_controls_thumbnail').last().addClass('active');
    }

    //Update controls position
    if(!$('.soff_browse_lot_images_controls_thumbnail.active').hasClass('shown')){
      let index = $('.soff_browse_lot_images_controls_thumbnail').index($('.soff_browse_lot_images_controls_thumbnail.active'));
      index -= index % thumbnailAmmount;


      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      for(var i = 0; i < thumbnailAmmount; i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(i + index).addClass('shown');
      }

      $('.soff_browse_lot_images_pagination_active').html(Math.ceil((index + 1) / thumbnailAmmount));
    }
    resetTouchZoom();
  });

  $('.soff_browse_lot_images_display_next').click(function(){
    //Disable full screen zoom when next/prev buttons are clicked
    $('#soff_browse_lot_images').removeClass('soff_fullscreen_gallery_zoom');

    //Kills fadeIn
    $('.soff_browse_lot_images_display_image.shown').stop(true, true);
    //Kills fadeOut
    $('.soff_browse_lot_images_display_image.shown').stop(true, true);

    //Display next image
    if(!$('.soff_browse_lot_images_display_image').last().hasClass('shown')){
      $('.soff_browse_lot_images_display_image.shown').fadeOut('fast', function(){
        $(this).removeClass('shown').next().addClass('shown').hide().fadeIn('fast');
      })
      $('.soff_browse_lot_images_controls_thumbnail.active').removeClass('active').next().addClass('active');
    }
    else{
      $('.soff_browse_lot_images_display_image.shown').fadeOut('fast', function(){
        $(this).removeClass('shown');
        $('.soff_browse_lot_images_display_image').first().addClass('shown').hide().fadeIn('fast');
      })
      $('.soff_browse_lot_images_controls_thumbnail.active').removeClass('active');
      $('.soff_browse_lot_images_controls_thumbnail').first().addClass('active');
    }

    //Update controls position
    if(!$('.soff_browse_lot_images_controls_thumbnail.active').hasClass('shown')){
      let index = $('.soff_browse_lot_images_controls_thumbnail').index($('.soff_browse_lot_images_controls_thumbnail.active'));
      index -= index % thumbnailAmmount;

      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      for(var i = 0; i < thumbnailAmmount; i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(i + index).addClass('shown');
      }

      $('.soff_browse_lot_images_pagination_active').html(Math.ceil((index + 1) / thumbnailAmmount));
    }
    resetTouchZoom();
  });

  //Thumbnail controls
  $('.soff_browse_lot_images_controls_thumbnail').click(function(){

    //Kills fadeIn
    $('.soff_browse_lot_images_display_image.shown').stop(true, true);
    //Kills fadeOut
    $('.soff_browse_lot_images_display_image.shown').stop(true, true);

    //Display selected image
    let index = $('.soff_browse_lot_images_controls_thumbnail').index(this);
    $('.soff_browse_lot_images_display_image.shown').fadeOut('fast', function(){
      $(this).removeClass('shown');
      $('.soff_browse_lot_images_display_image').eq(index).addClass('shown').hide().fadeIn('fast');
    })
    $('.soff_browse_lot_images_controls_thumbnail.active').removeClass('active');
    $(this).addClass('active');
    resetTouchZoom();
  });

  //Controls previous/next
  $('.soff_browse_lot_images_controls_next').click(function(){
    let index = $('.soff_browse_lot_images_controls_thumbnail').index($('.soff_browse_lot_images_controls_thumbnail.shown').last());
    if(!$('.soff_browse_lot_images_controls_thumbnail').last().hasClass('shown')){
      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      for(var i = 1; i < (thumbnailAmmount + 1); i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(i + index).addClass('shown');
      }
    }
    else{
      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      for(var i = 0; i < thumbnailAmmount; i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(i).addClass('shown');
      }
    }
    if($('.soff_browse_lot_images_pagination_active').html() < $('.soff_browse_lot_images_pagination_total').html()){
      $('.soff_browse_lot_images_pagination_active').html(parseInt($('.soff_browse_lot_images_pagination_active').html()) + 1);
    }
    else{
      $('.soff_browse_lot_images_pagination_active').html('1');
    }
    resetTouchZoom();
  });

  $('.soff_browse_lot_images_controls_prev').click(function(){
    let index = $('.soff_browse_lot_images_controls_thumbnail').index($('.soff_browse_lot_images_controls_thumbnail.shown').first());
    if(!$('.soff_browse_lot_images_controls_thumbnail').first().hasClass('shown')){
      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      for(var i = 1; i < (thumbnailAmmount + 1); i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(index - i).addClass('shown');
      }
    }
    else{
      let iterations = $('.soff_browse_lot_images_controls_thumbnail').length % thumbnailAmmount;
      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      if(iterations === 0){
        iterations = thumbnailAmmount;
      }
      for(var i = 1; i < (iterations + 1); i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(index - i).addClass('shown');
      }
    }
    if($('.soff_browse_lot_images_pagination_active').html() > 1){
      $('.soff_browse_lot_images_pagination_active').html($('.soff_browse_lot_images_pagination_active').html() - 1);
    }
    else{
      $('.soff_browse_lot_images_pagination_active').html($('.soff_browse_lot_images_pagination_total').html());
    }
    resetTouchZoom();
  });

  let zoomShouldOpen = true;

  //Change display to fullscreen
  $('.soff_browse_lot_images_display_image').click(function(e){
    if(!$('#soff_browse_lot_images').hasClass('soff_fullscreen_gallery')){
      $("#soff_browse_lot_images").appendTo("body");
      $('#soff_browse_lot_images').addClass('soff_fullscreen_gallery');
      $('body').addClass('no_scroll');

      thumbnailAmmount = 10;
      $('.soff_browse_lot_images_pagination_total').html(  $('.soff_browse_lot_images_pagination_total').data('pagination-large-total'));

      let index = $('.soff_browse_lot_images_controls_thumbnail').index($('.soff_browse_lot_images_controls_thumbnail.active'));
      index -= index % thumbnailAmmount;
      $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
      for(var i = 0; i < thumbnailAmmount; i++){
        $('.soff_browse_lot_images_controls_thumbnail').eq(i + index).addClass('shown');
      }

      $('.soff_browse_lot_images_pagination_active').html(Math.ceil((index + 1) / thumbnailAmmount));

      $('.soff_browse_lot_images_display_image img').each(function(){
        $(this).attr('src', $(this).data('img-full-src'));
      });
      $('.soff_browse_lot_images_display_image_container').addClass('soff_zoom_mouse_loop');
      if(fullScreenZoomEnabled==true && window.matchMedia('(pointer: fine)').matches) startZoom();
    } else {
      if(fullScreenZoomEnabled==true){
        if(!$('#soff_browse_lot_images').hasClass('soff_fullscreen_gallery_zoom') && zoomShouldOpen==true){
          let clickY = e.pageY - $('#soff_browse_lot_images').find('.shown img.soff_image_zoomable').offset().top;
          let clickX = e.pageX - $('#soff_browse_lot_images').find('.shown img.soff_image_zoomable').offset().left;
          let prop = $('#soff_browse_lot_images').find('.shown img.soff_image_zoomable').prop("naturalWidth")/$('#soff_browse_lot_images').find('.shown img.soff_image_zoomable').width();
          $('#soff_browse_lot_images').addClass('soff_fullscreen_gallery_zoom');
          $('#soff_browse_lot_images').find('.soff_browse_lot_images_display_image_container').scrollTop(clickY * prop -   $('#soff_browse_lot_images').find('.soff_browse_lot_images_display_image_container').innerHeight()/2).scrollLeft(clickX * prop -   $('#soff_browse_lot_images').find('.soff_browse_lot_images_display_image_container').innerWidth()/2);
        } else {
          zoomShouldOpen=true;
        }
      }
    }
    resetTouchZoom();
  })

  function startZoom(){
    makeUnselectable($('.soff_image_zoomable'));

    const ele = document.getElementsByClassName("soff_browse_lot_images_display_image_container")[0];

    $(ele).removeClass('soff_zoom_mouse_down').addClass('soff_zoom_mouse_up');

    let pos = { top: 0, left: 0, x: 0, y: 0 };

    const mouseDownHandler = function (e) {

      $(ele).removeClass('soff_zoom_mouse_up').addClass('soff_zoom_mouse_down');

      pos = {
        left: ele.scrollLeft,
        top: ele.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      };

      document.addEventListener('mousemove', mouseMoveHandler);
      document.addEventListener('mouseup', mouseUpHandler);
    };

    const mouseMoveHandler = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - pos.x;
      const dy = e.clientY - pos.y;

      // Scroll the element
      ele.scrollTop = pos.top - dy;
      ele.scrollLeft = pos.left - dx;
    };

    const mouseUpHandler = function (e) {
      if(pos.x==e.clientX && pos.y==e.clientY){
        //Mouse has not moved, we should close full screen zoom
        if($('#soff_browse_lot_images').hasClass('soff_fullscreen_gallery_zoom')){
          e.stopPropagation();
          $('.browse_lot_images_fullscreen_gallery_close').trigger('click');
          return;
        }

      }
      $(ele).removeClass('soff_zoom_mouse_down').addClass('soff_zoom_mouse_up');

      document.removeEventListener('mousemove', mouseMoveHandler);
      document.removeEventListener('mouseup', mouseUpHandler);
    };

    // Attach the handler
    ele.addEventListener('mousedown', mouseDownHandler);
  }

  //Close fullscreen
  $('.browse_lot_images_fullscreen_gallery_close').click(function(e){
    if($('#soff_browse_lot_images').hasClass('soff_fullscreen_gallery_zoom')){
      zoomShouldOpen=false;
      $('#soff_browse_lot_images').removeClass('soff_fullscreen_gallery_zoom');
      $('.soff_browse_lot_images_display_image_container').removeClass('soff_zoom_mouse_up').removeClass('soff_zoom_mouse_down');
      return;
    }
    $("#soff_browse_lot_images").prependTo(".soff_browse_lot_content").first();

    $('#soff_browse_lot_images').removeClass('soff_fullscreen_gallery');
    $('body').removeClass('no_scroll');

    thumbnailAmmount = 5;
    $('.soff_browse_lot_images_pagination_total').html(  $('.soff_browse_lot_images_pagination_total').data('pagination-small-total'));

    let index = $('.soff_browse_lot_images_controls_thumbnail').index($('.soff_browse_lot_images_controls_thumbnail.active'));
    index -= index % thumbnailAmmount;
    $('.soff_browse_lot_images_controls_thumbnail.shown').removeClass('shown');
    for(var i = 0; i < thumbnailAmmount; i++){
      $('.soff_browse_lot_images_controls_thumbnail').eq(i + index).addClass('shown');
    }

    $('.soff_browse_lot_images_pagination_active').html(Math.ceil((index + 1) / thumbnailAmmount));

    $('.soff_browse_lot_images_display_image img').each(function(){
      $(this).attr('src', $(this).data('img-medium-src'));
    });
    resetTouchZoom();
  });
  //Control fullscreen gallery with keyboard
  $("body").keydown(function(e) {
    if($('#soff_browse_lot_images').hasClass('soff_fullscreen_gallery')){
      if(e.keyCode == 37) { // left
        $('.soff_browse_lot_images_display_prev').trigger('click');
      }
      else if(e.keyCode == 39) { // right
        $('.soff_browse_lot_images_display_next').trigger('click');
      }
    }
  });

  function resetTouchZoom(){
    if(fullScreenZoomEnabled==true){
      document.querySelectorAll('.soff_image_zoomable').forEach(element => {
        element.style.width = "auto";
        element.style.height = "auto";
        element.style.maxWidth = "100%";
        element.style.maxHeight = "100%";
        element.setAttribute('data-scale', '1');
      });
    }
  }

  //Pinch zoom
  const pinchZoom = (imageElement) => {
    let imageElementScale = 1;
    let start = {};
    let scrollOrigin = {};
    let centerOrigin = {};

    // Calculate distance between two fingers
    const distance = (event) => {
      return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
    };

    imageElement.addEventListener('touchstart', (event) => {
      // console.log('touchstart', event);
      if (event.touches.length === 2 && document.getElementById('soff_browse_lot_images').classList.contains('soff_fullscreen_gallery')) {
        event.preventDefault(); // Prevent page scroll

        // Calculate where the fingers have started on the X and Y axis
        start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
        start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
        start.distance = distance(event);
        scrollOrigin.x = imageElement.parentNode.parentNode.scrollLeft;
        scrollOrigin.y = imageElement.parentNode.parentNode.scrollTop;
        centerOrigin.x = (imageElement.parentNode.parentNode.scrollWidth - imageElement.parentNode.parentNode.offsetWidth)/2;
        centerOrigin.y = (imageElement.parentNode.parentNode.scrollHeight - imageElement.parentNode.parentNode.offsetHeight)/2;
        if(!imageElement.hasAttribute('data-original-height')){
          imageElement.setAttribute('data-original-height', imageElement.offsetHeight);
          imageElement.setAttribute('data-original-width', imageElement.offsetWidth);
        }
      }
    });

    imageElement.addEventListener('touchmove', (event) => {
      // console.log('touchmove', event);
      if (event.touches.length === 1 && document.getElementById('soff_browse_lot_images').classList.contains('soff_fullscreen_gallery')) {
        let baseDeltaX = 0;
        if (!isNaN(imageElement.getAttribute('data-delta-x'))){
          baseDeltaX = Number(imageElement.getAttribute('data-delta-x'));
        }
        let baseDeltaY = 0;
        if (!isNaN(imageElement.getAttribute('data-delta-y'))){
          baseDeltaY = Number(imageElement.getAttribute('data-delta-y'));
        }
        deltaX = baseDeltaX + event.touches[0].pageX - start.x; // x2 for accelarated movement
        deltaY = baseDeltaY + event.touches[0].pageY - start.y; // x2 for accelarated movement
      }
      else if (event.touches.length === 2 && document.getElementById('soff_browse_lot_images').classList.contains('soff_fullscreen_gallery')) {
        event.preventDefault(); // Prevent page scroll

        // Safari provides event.scale as two fingers move on the screen
        // For other browsers just calculate the scale manually
        let scale;
        let baseScale = 0;
        if (imageElement.getAttribute('data-scale')){
          baseScale = imageElement.getAttribute('data-scale');
        }
        if (event.scale) {
          scale = baseScale * event.scale;
        } else {
          const deltaDistance = distance(event);
          scale = baseScale * (deltaDistance / start.distance);
        }
        imageElementScale = Math.min(Math.max(1, scale), 4);

        deltaX = (((event.touches[0].pageX + event.touches[1].pageX) / 2) - start.x) * 2; // x2 for accelarated movement
        deltaY = (((event.touches[0].pageY + event.touches[1].pageY) / 2) - start.y) * 2; // x2 for accelarated movement

        // Transform the image to make it grow and move with fingers
        imageElement.style.width = String(imageElement.getAttribute('data-original-width')*imageElementScale) + "px";
        imageElement.style.height = String(imageElement.getAttribute('data-original-height')*imageElementScale) + "px";
        imageElement.style.maxWidth = "none";
        imageElement.style.maxHeight = "none";
        imageElement.parentNode.parentNode.scrollTop = (imageElement.parentNode.parentNode.scrollHeight - imageElement.parentNode.parentNode.offsetHeight)/2 + (scrollOrigin.y - centerOrigin.y)*(scale-baseScale+1) - deltaY;
        imageElement.parentNode.parentNode.scrollLeft = (imageElement.parentNode.parentNode.scrollWidth - imageElement.parentNode.parentNode.offsetWidth)/2 + (scrollOrigin.x - centerOrigin.x)*(scale-baseScale+1) - deltaX;
      }
    });

    imageElement.addEventListener('touchend', (event) => {
      imageElement.setAttribute('data-scale', imageElementScale);
    });
  }

  if(fullScreenZoomEnabled==true){
    document.querySelectorAll('.soff_image_zoomable').forEach(element => {
      pinchZoom(element);
    });
  }


  //Hover zoom
  if(hoverZoomEnabled==true){
    let isOverImg = false;
    let imgActive = "";
    let proportions = 0;
    $('.soff_image_zoomable').hover(function(){
      isOverImg = true;
      imgActive = $(this);
      proportions = imgActive.prop("naturalWidth") / imgActive.width();
      $('.soff_zoom_container').css('background-image', 'url(\'' + $(this).data('img-full-src') + '\')');
      $('.soff_zoom_container').show();
    }, function(){
      isOverImg = false;
      $('.soff_zoom_container').hide();
    });

    $(document).mousemove(function(event) {
      if(isOverImg){
        let posY = (-event.pageY + imgActive.offset().top) * proportions +   $('.soff_zoom_container').innerHeight()/2;
        let posX = (-event.pageX + imgActive.offset().left) * proportions +  $('.soff_zoom_container').innerWidth()/2;
        $('.soff_zoom_container').css('background-position', posX+ 'px ' + posY + 'px');
      }
    });
  }

  $(".soff_browse_lot_images_display_download_pdf").click(function(e) {
    // Do something
    e.stopPropagation();
  });
  $(".soff_browse_lot_thumbnail_display_download_pdf").click(function(e) {
    // Do something
    e.stopPropagation();
  });
});
